import {
    submissionDealAmount,
    loiThresholdAmount,
    agreementThresholdAmount,
} from './daewooFinance';

export const LEGAL_STATUS_FILTERS = [
    { id: 'all', label: 'All' },
    { id: 'not_sent', label: 'Not Sent' },
    { id: 'requested', label: 'Requested' },
    { id: 'rejected', label: 'Rejected' },
    { id: 'submitted', label: 'Submitted' },
];

export function getActiveStages(stages) {
    return [...(stages || [])].filter(s => s.active !== false).sort((a, b) => a.order - b.order);
}

export function stageLabelFor(stages, order) {
    return getActiveStages(stages).find(s => s.order === order)?.label || '—';
}

/** Map micro-stage order + label into filter buckets (matches reference workflow). */
export function legalStatusBucket(stageOrder, stageLabel, stages) {
    const label = String(stageLabel || '');
    const active = getActiveStages(stages);
    const last = active[active.length - 1];

    if (/reject/i.test(label)) return 'rejected';
    if (stageOrder === 1) return 'not_sent';
    if (stageOrder === 2) return 'requested';
    if (last && stageOrder === last.order) return 'submitted';
    if (/completed/i.test(label)) return 'submitted';
    if (stageOrder > 2) return 'submitted';
    return 'not_sent';
}

export const BUCKET_META = {
    not_sent:  { label: 'Not Sent',  dot: 'bg-amber-400',   chip: 'bg-amber-50 text-amber-900 ring-amber-200/80' },
    requested: { label: 'Requested', dot: 'bg-violet-400',  chip: 'bg-violet-50 text-violet-900 ring-violet-200/80' },
    rejected:  { label: 'Rejected',  dot: 'bg-rose-400',    chip: 'bg-rose-50 text-rose-900 ring-rose-200/80' },
    submitted: { label: 'Submitted', dot: 'bg-slate-400',   chip: 'bg-slate-100 text-slate-800 ring-slate-200/80' },
};

export function agreementStageOrder(sub, stages) {
    if (sub.agreementCurrentStageOrder != null) return sub.agreementCurrentStageOrder;
    const active = getActiveStages(stages);
    const lastOrder = active[active.length - 1]?.order || 15;
    if (sub.currentStage === 'paid') return lastOrder;
    if (sub.currentStage === 'agreement') return 2;
    return 1;
}

export function enrichLegalRow(sub, { paymentSettings, stages, workflow }) {
    const deal = submissionDealAmount(sub.data);
    const finalPayable = Number(sub.data?.finalPayableAmount || deal);
    const loiThreshold = loiThresholdAmount(deal, finalPayable, paymentSettings);
    const agreementThreshold = agreementThresholdAmount(deal, finalPayable, paymentSettings);
    const collected = Number(sub.totalReceived || 0);
    const pct = Number(sub.receivedPercent || 0);
    const balance = Number(sub.balanceAmount ?? Math.max(0, finalPayable - collected));

    const stageOrder = workflow === 'loi'
        ? (sub.loiCurrentStageOrder ?? 1)
        : agreementStageOrder(sub, stages);

    const stageLabel = stageLabelFor(stages, stageOrder);
    const bucket = legalStatusBucket(stageOrder, stageLabel, stages);
    const threshold = workflow === 'loi' ? loiThreshold : agreementThreshold;
    const baseOk = sub.status === 'approved' && (sub.clientStatus || 'active') === 'active';
    const loiEligible = baseOk && collected >= loiThreshold;
    const agreementEligible = baseOk && deal > 0 && collected >= agreementThreshold;

    return {
        sub,
        id: sub._id,
        name: sub.data?.name || 'Unnamed',
        deal,
        finalPayable,
        collected,
        pct,
        balance,
        loiThreshold,
        agreementThreshold,
        threshold,
        stageOrder,
        stageLabel,
        bucket,
        loiEligible,
        agreementEligible,
        eligible: workflow === 'loi' ? loiEligible : agreementEligible,
    };
}
